import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { userSelector } from 'selectors/user/userSelector';

const withBasketLovesProps = connect(createStructuredSelector({ user: userSelector }));

export default withBasketLovesProps;
